import { Container, Row, Col, Tab } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.jpeg";
import projImg2 from "../assets/img/project-img2.jpeg";
import projImg3 from "../assets/img/project-img3.jpeg";
import projImg4 from "../assets/img/project-img4.jpeg";
import projImg5 from "../assets/img/project-img5.jpeg";
import projImg6 from "../assets/img/project-img6.jpeg";

import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "BMW Legal Website",
      description: "For Managing Cases",
      imgUrl: projImg1,
      link: "https://bmwlegal.netlify.app/"
    },
    {
      title: "Brioche Burger",
      description: "Showcase Food Outlet",
      imgUrl: projImg2,
      link: "https://brioche-burger.netlify.app/"
    },
    {
      title: "Opulence Oasis",
      description: "Travel Booking site",
      imgUrl: projImg3,
      link: "https://opulence-oasis.netlify.app/"
    },
    {
      title: "Employee Management System",
      description: "Manage Employee Details",
      imgUrl: projImg4,
      link: "https://employee-master.netlify.app/#/employee-list"

    },
    {
      title: "CarFae",
      description: "Design & Development",
      imgUrl: projImg5,
      link: "https://carfae.netlify.app/"
    },
    {
      title: "Samrat Investments",
      description: "Investment Product website",
      imgUrl: projImg6,
      link: "https://samratinvestments.netlify.app/"
    },
  ];

  return (
    <section className="project" style={{paddingBottom: "20px"}} id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Projects</h2>
                  <p>Crafting captivating digital experiences, one pixel at a time. Elevating your online presence with innovative web solutions</p>
                  <Tab.Container id="projects-tabs">
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard 
                                key={index}
                                {...project}
                              />
                            )
                          })
                        }
                      </Row>
                    </Tab.Content>
                  </Tab.Container>
                  <p>Many More project are on way...</p>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="bacground"></img>
    </section>
  )
}
